var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldPenTool2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.01 2.89c-.06-.77-.7-1.39-1.49-1.39h-1c-.79 0-1.42.61-1.49 1.38-3.88.64-6.79 3.9-7.01 7.82-.71.12-1.25.73-1.25 1.47v1c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-1c0-.74-.54-1.35-1.25-1.47a6.91 6.91 0 0 1 5.56-6.31c.17.64.75 1.11 1.44 1.11h1c.69 0 1.26-.47 1.44-1.1 3.04.61 5.31 3.2 5.52 6.3-.71.12-1.25.73-1.25 1.47v1c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-1c0-.74-.54-1.36-1.25-1.47a8.41 8.41 0 0 0-6.97-7.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.13 18H9.88l-1.64-1.45c-.95-.78-.95-1.38-.23-2.3l2.89-3.66c.2-.25.43-.42.69-.51.27-.09.56-.09.84 0 .25.09.48.26.69.51L16 14.24c.73.92.69 1.49-.23 2.31L14.13 18zM10.73 22c-.92 0-1.61-.75-1.43-1.55l.31-1.39a.6.6 0 0 1 .59-.47h3.65c.28 0 .52.19.59.47l.31 1.39c.19.85-.45 1.55-1.43 1.55h-2.59z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPenTool2);
export default __webpack_public_path__ + "static/media/vuesax-bold-pen-tool-2.8a75621148ad59014c7874bdcf1cb9c6.svg";
export { ForwardRef as ReactComponent };